import React from 'react';
import Tile from '../../../common/components/Tile/Tile';
import { List as ListIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';
import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';

const UpdateJobs = (props) => {
  return (
    <Tile
      TitleIcon={ListIcon}
      title={'Update jobs'}
      helpTag="update_jobs"
      RightContent={
        <div>
          <PermissionsCheck permission={PermissionsEnum.CREATE_UPDATE_JOBS}>
            <Button
              variant="contained"
              data-qa="qa-newUpdateJob"
              className="u-ml-double"
              color="primary"
              onClick={() => props.newUpdateJob()}
            >
              NEW UPDATE JOB
            </Button>
          </PermissionsCheck>
        </div>
      }
    >
      <TableEnhancedContainer
        data={props.data}
        onClickRow={props.onClickRow}
        className="UpdateJobsTable"
        columns={props.columnConfigs}
        enableHideColumns={true}
        enableActionButtons={true}
      />
    </Tile>
  );
};

export default UpdateJobs;
